exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".generate-booking-container {\n    top: 160px;\n    background: #f0f0f0;\n    padding: 15px 25px 25px 25px;\n}\n\n.lfwms-btn-default {\n    margin: 0px 4px 0px 0px;\n    font-size: 13px;\n    padding-right: 20px;\n}\n\n.lfwms-btn-default:hover {\n    color: #ffffff;\n    background-color: #0073AB;\n}\n\n.generate-booking-container .message {\n    margin-bottom: 20px;\n    padding-top: 10px;\n    padding-bottom: 50px;\n}\n\n.lfwms-heading-primary {\n    font-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/dock-door-booking-popups/generate-booking-popup/generate-booking-popup.component.css
// module id = ../../../../../src/app/shared/lookup/dock-door-booking-popups/generate-booking-popup/generate-booking-popup.component.css
// module chunks = main